import { bankingProductLoanReceiptsDataSelectorConfig } from './bankingProductLoanReceiptsData'
import { bankingProductLoanReceiptsDownloadSelectorConfig } from './bankingProductLoanReceiptsDownload'
import { bankingProductMovementsDataSelectorConfig } from './bankingProductMovementsData'
import { bankingProductMovementsDownloadSelectorConfig } from './bankingProductMovementsDownload'
import { operationsSelectorConfig } from './operations'
import { operationsDownloadSelectorConfig } from './operationsDownload'

export const selectorsConfig = {
  ...operationsSelectorConfig,
  ...operationsDownloadSelectorConfig,
  ...bankingProductMovementsDataSelectorConfig,
  ...bankingProductMovementsDownloadSelectorConfig,
  ...bankingProductLoanReceiptsDataSelectorConfig,
  ...bankingProductLoanReceiptsDownloadSelectorConfig,
}
